import { RESET_ALL_STATES } from "../actions/actions";

const initialState = {
  isVerified: false,
  isAuthenticated: false,

};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_VERIFIED":
      return {
        ...state,
        isVerified: true,
      };

    case "LOGOUT":
      return {
        ...state,
        isVerified: false,
        isAuthenticated: false,
      };

    case "LOGIN":
      return {
        ...state,
        isAuthenticated: true,
      };
 
    case RESET_ALL_STATES:
      return initialState;

    default:
      return state;
  }
};

export default sessionReducer;
